module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user != '') ? _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.fill_info == '' && _vm.hianypotlas_fields.length > 0) ? _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Nemzeti felsőoktatási ösztöndíj hiánypótlás")]), _vm._v(" "), _c('div', {
    staticClass: "article-text"
  }, [_vm._v("\n            Az Ön által beküldött "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("eredeti")]), _vm._v(" pályázat az alábbi "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'assets/urlap_kitoltesek/' + _vm.fill.pdf_filename
    }
  }, [_vm._v("linkre")]), _vm._v(" kattintva tekinthető meg.\n            "), _c('br'), _c('br'), _vm._v("Az "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("érvényben lévő")]), _vm._v(" pályázata (" + _vm._s(_vm.fill.status) + ") a következő "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'assets/urlap_kitoltesek/' + _vm.fill.new_pdf_filename + '?v=' + (new Date())
    }
  }, [_vm._v("linkre")]), _vm._v(" kattintva tekinthető meg. A bírálók esetleges megjegyzései, módosításai az adatlapon eltérő betűszínnel láthatóak\n          ")]), _vm._v(" "), (_vm.blockTitleShow(['nyelvtudas'])) ? _c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Nyelvtudás\n          ")]) : _vm._e(), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "nyelvtudas",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), (_vm.blockTitleShow(['st1', 'st2', 'st3', 'st4', 'st5', 'st6', 'st7', 'st8'])) ? _c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Szakmai tevékenység\n          ")]) : _vm._e(), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "st1",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "st2",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "st3",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "st4",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "st5",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "st6",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "st7",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "st8",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), (_vm.blockTitleShow(['ks1', 'ks2', 'ks3', 'ks4', 'ks5', 'ks6'])) ? _c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Közéleti, sport és egyéb tevékenység\n          ")]) : _vm._e(), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "ks1",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "ks2",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "ks3",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "ks4",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "ks5",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('UploadHandlerHianypotlas', {
    attrs: {
      "name": "ks6",
      "errors": _vm.errors,
      "max_uploaded_files": "5",
      "hianypotlas_fields": _vm.hianypotlas_fields
    },
    on: {
      "change": function (name, value) {
        _vm.changeValue(name, value);
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Hiánypótlás beküldése")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Nemzeti felsőoktatási ösztöndíj hiánypótlás")]), _vm._v(" "), _c('div', {
    staticClass: "article-text"
  }, [_vm._v("\n            " + _vm._s(_vm.fill_info) + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage-head-image",
    staticStyle: {
      "background-image": "url('assets/img/subpage-head.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n        Nemzeti felsőoktatási ösztöndíj\n        "), _c('span', [_vm._v("Hiánypótlás")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f33010"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/nemzeti_felsooktatasi_osztondij_hianypotlas.vue
// module id = 362
// module chunks = 0